import React, { Component } from 'react';
import { Form, Row, Col, Input, Select } from 'antd';

const { Option } = Select;

export default class TextFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      operator: this.props.operator ? this.props.operator : 'CONTAIN',
      field: props.field
    };
  }

  filterOperator = [
    { id: 'EQUAL', label: 'Equal' },
    { id: 'NOT_EQUAL', label: 'Not Equal' },
    { id: 'CONTAIN', label: 'Contain' },
    { id: 'DOES_NOT_CONTAIN', label: 'Does not Contain' },
    { id: 'STARTS_WITH', label: 'Start With' },
    { id: 'ENDS_WITH', label: 'End With' },
    { id: 'NOT_IN', label: 'Not In' },
    { id: 'IS_EMPTY', label: 'Is Empty' },
    { id: 'NOT_EMPTY', label: 'Not Empty' },
    { id: 'IS', label: 'Is' }
  ];

  onElementChange = e => {
    e.preventDefault();

    this.setState(
      {
        value: this.props.form.getFieldsValue()[`${this.state.field}`]
      },
      this.sentTOParent
    );
  };

  onOperatorChange = e => {
    this.setState({ operator: e }, this.sentTOParent);
  };

  sentTOParent = () => {
    this.props.onFilter(this.state);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item>
            {getFieldDecorator(`${this.state.field}_operator`, {
              initialValue: this.state.operator,
              rules: [{ required: true, message: 'Please select your country!' }]
            })(
              <Select onChange={this.onOperatorChange} style={{ width: '100%' }}>
                {this.filterOperator.map((item, key) => (
                  <Option key={item.id} value={item.id}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item>
            {getFieldDecorator(`${this.state.field}`, {
              rules: []
            })(<Input placeholder={this.props.field} allowClear onBlur={this.onElementChange} />)}
          </Form.Item>
        </Col>
      </Row>
    );
  }
}
